import { render, staticRenderFns } from "./EventApplicationDashlet.vue?vue&type=template&id=a5e07214"
import script from "./EventApplicationDashlet.vue?vue&type=script&lang=js"
export * from "./EventApplicationDashlet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports